import React from 'react';
import { CheckCircle2 } from 'lucide-react';

interface VerifiedAreaCheckProps {
    /** Tooltip; defaults to the verified wording. */
    title?: string;
    size?: number;
}

/**
 * Green check shown after a golvyta that is "uppmätt på ritning" and still
 * current (Helpers/floorAreaVerification.ts). Inline so it sits in a text
 * row (InfoPanel value, room list metadata).
 */
const VerifiedAreaCheck: React.FC<VerifiedAreaCheckProps> = ({ title = 'Uppmätt på ritning', size = 15 }) => (
    <CheckCircle2
        size={size}
        color="#198754"
        aria-label={title}
        role="img"
        style={{ marginLeft: '6px', verticalAlign: 'middle', flexShrink: 0 }}
    />
);

export default VerifiedAreaCheck;
